$.fancybox.defaults.smallBtn = false;
$.fancybox.defaults.infobar = false;
$.fancybox.defaults.padding = 0;
$.fancybox.defaults.gutter = 0;
$.fancybox.defaults.toolbar = true;
$.fancybox.defaults.buttons = ['close'];
$.fancybox.defaults.mobile = {
  baseClass: 'fancybox-mobile',
  transitionEffect: false,
  animationEffect: "fade"
};

$.fancybox.defaults.btnTpl = {
  arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left icon-arrowleft" title="{{PREV}}"></button>',
  arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right icon-arrowright" title="{{NEXT}}"></button>',
  close: '<button data-fancybox-close class="fancybox-button fancybox-button--close icon-closefat" title="{{CLOSE}}"></button>'
};

$.fancybox.defaults.spinnerTpl = '<div class="fancybox-loading icon-blades"></div>';
// Open/close animation type
// Possible values:
//   false            - disable
//   "zoom"           - zoom images from/to thumbnail
//   "fade"
//   "zoom-in-out"
//
$.fancybox.defaults.animationEffect = "zoom-in-out";

//   "fade'
//   "slide'
//   "circular'
//   "tube'
//   "zoom-in-out'
//   "rotate'
$.fancybox.defaults.transitionEffect = "fade";
$.fancybox.defaults.transitionDuration = 500;
$.fancybox.defaults.touch = {
  vertical: false, // Allow to drag content vertically
  momentum: false // Continue movement after releasing mouse/touch when panning
};
$.fancybox.defaults.helpers = {
  overlay: {
    closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
    speedOut: 200, // duration of fadeOut animation
    showEarly: true, // indicates if should be opened immediately or wait until the content is ready
    css: {}, // custom CSS properties
    locked: true // if true, the content will be locked into overlay
  }
};
$.fancybox.defaults.ajax = {
  settings: {
    data: {
      fancybox: false
    }
  }
};

$.fancybox.defaults.slideShow.autoStart = true;

$.fancybox.defaults.iframe.css.width = '820px';

$.fancybox.defaults.hideScrollbar = false;

$.fancybox.defaults.idleTime = false;

$.fancybox.defaults.mobile.beforeShow = function (instance, current) {
  $('html').addClass('html--noscroll--mobile');
}

$.fancybox.defaults.beforeShow = function (instance, current) {
  if (!$('html').hasClass('html--noscroll')) {
    window.htmlscrolltop = $('html').scrollTop();
    $('html').css('margin-top', -window.htmlscrolltop).addClass('html--noscroll');
  }
}
$.fancybox.defaults.mobile.beforeClose = function (instance, current) {
  $('html').removeClass('html--noscroll--mobile');
}
$.fancybox.defaults.beforeClose = function (instance, current) {
  $('html').css('margin-top', 0).removeClass('html--noscroll');
  window.scrollTo(0, window.htmlscrolltop);
};

window.fancybox = $.fancybox

/*
if (window.location.hash == '#fbpopup') {
  window.fancybox.open({
    src: "/popupfb/?popup=1",
    type: 'iframe'
  });
}
*/